import { FieldHtmlNameUtil } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';
import AbstractSubmitSignupScreen from './AbstractSubmitSignupScreen';

export default class StandardDetailsScreen extends AbstractSubmitSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-details-standard';

  public getThisScreensVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.companyName),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.jobTitle),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.phoneNumber),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.currentCadSystem).shuffleOptionList(),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.howDidYouHearAboutUs),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.tosConsentAccepted),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.privacyConsentAccepted),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.recaptcha),
      }),
    ];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const {
      intent, completedDetailsScreens, formSubmitStatus, emailCheckCode,
    } = this.sessionInfo.value;

    if (emailCheckCode === 401 || emailCheckCode === 204 || emailCheckCode === 422) {
      return false;
    }
    if (formSubmitStatus !== null && formSubmitStatus !== 'submit-failed') {
      return false;
    }
    if (intent === null || !intent.compareTo(UnifiedSignupIntent.standardIntent)) {
      return false;
    }
    if (completedDetailsScreens.length !== 0) {
      return false;
    }

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 85;
  }
}
